import { useSelector } from 'react-redux';

import { useApiQuery } from 'theSource/utils';
import { selectIsAuthenticated } from 'theSource/features';
import { GET_SUBSCRIBER_DOCUMENTS_QUERY_KEY } from './utils';
import { useConfigurationQuery } from 'theSource/queries';
import { DocumentRequestResponseDto } from 'enrollment/types/dtos';

export interface UseDocumentRequestQueryProps {
  lumosEnabled?: boolean;
  orgPlanYearId?: number;
  enrollmentContextValue?: string;
}

export interface UseDocumentRequestQueryOutput {
  documentRequestsData?: DocumentRequestResponseDto;
  isLoadingDocumentRequests?: Boolean;
  isFetchingDocumentRequests?: Boolean;
}

export const useDocumentRequestQuery = ({
  lumosEnabled,
  orgPlanYearId,
  enrollmentContextValue,
}: UseDocumentRequestQueryProps): UseDocumentRequestQueryOutput => {
  const { configuration } = useConfigurationQuery();
  const apiHost = configuration?.apiHost;

  const isAuthenticated = useSelector(selectIsAuthenticated);

  const {
    data: documentRequestsData,
    isLoading: isLoadingDocumentRequests,
    isFetching: isFetchingDocumentRequests,
  } = useApiQuery<DocumentRequestResponseDto>({
    // using dynamic query key to avoid cache conflicts as you can invalidate all 'subscriber_documents' without providing orgPlanYearId
    queryKey: [GET_SUBSCRIBER_DOCUMENTS_QUERY_KEY, orgPlanYearId || 'any'],
    config: {
      baseURL: `${apiHost}/v2/self_service`,
    },
    endpoint: '/documents/subscriber_documents',
    params: {
      enrollment_type: enrollmentContextValue,
      org_plan_year_id: orgPlanYearId || undefined,
      life_event_completed: false,
    },
    enabled: Boolean(isAuthenticated) && lumosEnabled,
  });

  return {
    documentRequestsData,
    isLoadingDocumentRequests,
    isFetchingDocumentRequests,
  };
};
